let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("20Ct9"), load("7z23r"), load("lXHHP")]).then(() => parcelRequire('9kyXU'));